import type { AttendeeLearningRecordResponse } from "@verity-connect/contracts";

export type SessionFollowupKind = "saved" | "writing" | "failed" | "ready" | "waiting";

export function sessionFollowupKind(
  response: AttendeeLearningRecordResponse,
  hasLocalNote: boolean,
): SessionFollowupKind {
  if (response.record) return "saved";
  if (response.draftAssistance.request?.state === "queued" || response.draftAssistance.request?.state === "processing") return "writing";
  if (response.draftAssistance.request?.state === "failed") return "failed";
  const hasTranscript = response.evidence.sources.some((source) => source.kind === "recording_transcript" && source.text !== null);
  if (hasTranscript || hasLocalNote || response.evidence.coverage.draftAllowed) return "ready";
  return "waiting";
}
